define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/UserContext", "./productActions"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, UserContext, ProductActions) {
    "use strict";
    var Products = /** @class */ (function () {
        function Products() {
            this.canExport = ko.observable(UserContext.hasAccess("Admin,Product.Export"));
            this.userCanEditProduct = ko.observable(UserContext.hasAccess("Admin,Product.Edit,Product.Delete"));
            this.userCanDeleteProduct = ko.observable(UserContext.hasAccess("Admin,Product.Delete"));
            this.filterByAny = ko.observable("");
            this.productActions = new ProductActions();
        }
        Products.prototype.init = function () {
            var self = this;
            $("#page-title").text("Products");
            self.productActions.actionCallback = function (type) {
                self.productTable.refresh();
            };
            tools.ajaxGet({
                url: "/Products/GetLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.productCategoryLookupList = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initGrid(self.productCategoryLookupList.GridStructures.ProductsStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        Products.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblProductsKendo";
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "100px",
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEditProduct) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    if (self.userCanDeleteProduct) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.productTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Products/GetProducts",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#products-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    }
                },
                gridId: gridId,
                showPagerOnTop: false,
                allowBulkEdits: {
                    enabled: true,
                    customDataAttributes: 'data-name="#=Name#"'
                },
                enableExport: {
                    entityName: "Product",
                    title: "Products",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.productTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.productTable.getGridData().dataSource.read();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.editProduct(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.productActions.deleteProductConfirm(data.Id, data.Name);
                event.preventDefault();
            });
        };
        Products.prototype.editProduct = function (id) {
            var self = this;
            self.productActions.editProduct(id);
        };
        Products.prototype.bulkEdit = function () {
            var self = this;
            var listOfIds = [];
            $("#tblProductsKendo .check-row:checked").each(function () {
                listOfIds.push($(this).data());
            });
            if (listOfIds.length > 0 && listOfIds.length <= 1000) {
                self.productActions.bulkEditProducts(listOfIds);
            }
            else if (listOfIds.length > 1000) {
                tools.error("You can edit only 1000 items at a time");
            }
            else {
                tools.error("Please select at least one item to edit");
            }
        };
        Products.prototype.exportTo = function () {
            var self = this;
            if (self.canExport) {
                self.productTable.exportTo();
            }
        };
        Products.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("Product");
                dataLogs.open("Products logs");
                event.preventDefault();
            }
        };
        return Products;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Products/Index")) {
            log.log("Initialize Products list");
            $(function () {
                (new Products()).init();
            });
        }
    }, 0);
    return Products;
});
//# sourceMappingURL=products.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/products/products.js
// module id = 292
// module chunks = 2